// extracted by mini-css-extract-plugin
export default {"link":"Link_link__qEOLZ","action":"Link_action__uqYzb","densed":"Link_densed__kgTb4"};